export default __webpack_public_path__ + "static/media/MBChurchillClosed.0a086e31.jpg";